import axiosInstance from "./AxiosInstance";

const getProducts = async (searchQuery?: string) => {
    const res = await axiosInstance.get("/api/products/", {
      params: searchQuery ? { search: searchQuery } : {},
    });
    return res.data;
};

export default getProducts;
